// extracted by mini-css-extract-plugin
module.exports = {"mapBtn":"UaMap_mapBtn__qpdIb","logoMap":"UaMap_logoMap__jGIo0","active":"UaMap_active__1jzWs"};